var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ selectionMode: _vm.selectionMode, insertMode: _vm.insertMode },attrs:{"id":"app"}},[_c('MainView'),_c('ActionMenu'),_c('AccountMenu'),_c('TypeMenu'),_c('DateMenu'),_c('ListMenu'),_c('ColorMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }